/**
 * @generated SignedSource<<17fecc979616e11e490d509529d4d7ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoEditScheduledArchiveAtSaveMutation$variables = {
  scheduledArchiveAt?: string | null;
  workspaceTodoId: string;
};
export type WorkspaceTodoEditScheduledArchiveAtSaveMutation$data = {
  readonly todoWorkspace: {
    readonly updateScheduledArchiveAt: {
      readonly id: string;
    };
  };
};
export type WorkspaceTodoEditScheduledArchiveAtSaveMutation = {
  response: WorkspaceTodoEditScheduledArchiveAtSaveMutation$data;
  variables: WorkspaceTodoEditScheduledArchiveAtSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scheduledArchiveAt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceTodoId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceTodoId"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newArchiveAt",
            "variableName": "scheduledArchiveAt"
          }
        ],
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "updateScheduledArchiveAt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditScheduledArchiveAtSaveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodoEditScheduledArchiveAtSaveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5c72539112471b072f379b4e99470e2d",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditScheduledArchiveAtSaveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditScheduledArchiveAtSaveMutation(\n  $workspaceTodoId: ID!\n  $scheduledArchiveAt: String\n) {\n  todoWorkspace(id: $workspaceTodoId) {\n    updateScheduledArchiveAt(newArchiveAt: $scheduledArchiveAt) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e1d80949ff1cbbc2add96e0b7865213";

export default node;
